<!--
~ Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
~
~ The information and source code contained herein is the exclusive property of
~ Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
~ or in part without the explicit written authorization from Anvilor Solutions LLC.
-->

<div id="screen-wrap" [class.narrow-screen-layout]="media.active.ltSm$ | async">
  <!-- Header -->
  <div id="header" class="nvt-bar-1">
    <div class="content-wrap header-content fxr-b-c">
      <div class="fxr-s-c">
        @if ((headerLogo$ | async) !== null) {
        <div class="pd-tb-sm fxr-c-c mg-right-sm">
          <img [src]="headerLogo$ | async" alt="logo" class="main-logo" />
        </div>
        }
        <h1 [innerHTML]="control.title$ | async | trustedHtml" id="survey-title"></h1>
      </div>
      @if (control.submitButtonControl$ | async; as submitButtonControl) {
      <app-submit-button-control [internalId]="submitButtonControl.iid"></app-submit-button-control>
      }
    </div>
  </div>

  <!-- Main Content Wrap. -->
  <div class="content-container content-wrap">
    @if (control.bodyControl$ | async; as bodyControl) {
    <div class="scrollable-content">
      <ng-template [ruiControlOutlet]="bodyControl.iid"></ng-template>
    </div>
    }
  </div>
</div>
